import { render, staticRenderFns } from "./ExportQuestionForGpt.vue?vue&type=template&id=745e3567&"
import script from "./ExportQuestionForGpt.vue?vue&type=script&lang=js&"
export * from "./ExportQuestionForGpt.vue?vue&type=script&lang=js&"
import style0 from "./ExportQuestionForGpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports